import vuetifyPlLocale from 'vuetify/src/locale/pl.ts'

export default {
  ...vuetifyPlLocale
}
